import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    tabBody: {
        [theme.breakpoints.down('sm')]: {
            // marginLeft:'-40px'
        }
    }
}));